import { render, staticRenderFns } from "./002zhihuidangjian.vue?vue&type=template&id=2a7b247f&scoped=true&"
import script from "./002zhihuidangjian.vue?vue&type=script&lang=js&"
export * from "./002zhihuidangjian.vue?vue&type=script&lang=js&"
import style0 from "./002zhihuidangjian.vue?vue&type=style&index=0&id=2a7b247f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b247f",
  null
  
)

export default component.exports